import { render, staticRenderFns } from "./CostBearerServices.vue?vue&type=template&id=6cc3ba02&"
import script from "./CostBearerServices.vue?vue&type=script&lang=ts&"
export * from "./CostBearerServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports